<script>
import TemplatesPicker from './TemplatesPicker.vue';
import WhatsAppTemplateReply from './WhatsAppTemplateReply.vue';
import TeleportWithDirection from 'dashboard/components-next/TeleportWithDirection.vue';
export default {
  components: {
    TemplatesPicker,
    WhatsAppTemplateReply,
    TeleportWithDirection,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    inboxId: {
      type: Number,
      default: undefined,
    },
    contact: {
      type: Object,
      default: null,
    },
  },
  emits: ['onSend', 'cancel', 'close', 'update:show'],
  data() {
    return {
      selectedWaTemplate: null,
    };
  },
  computed: {
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
    modalHeaderContent() {
      return this.selectedWaTemplate
        ? this.$t('WHATSAPP_TEMPLATES.MODAL.TEMPLATE_SELECTED_SUBTITLE', {
            templateName: this.selectedWaTemplate.name,
          })
        : this.$t('WHATSAPP_TEMPLATES.MODAL.SUBTITLE');
    },
  },
  methods: {
    pickTemplate(template) {
      this.selectedWaTemplate = template;
    },
    onResetTemplate() {
      this.selectedWaTemplate = null;
    },
    onSendMessage(message) {
      this.$emit('onSend', message);
    },
    onClose() {
      this.$emit('cancel');
      this.$emit('close');
    },
  },
};
</script>

<template>
  <TeleportWithDirection to="body">
    <woot-modal v-model:show="localShow" :on-close="onClose" size="modal-big">
      <woot-modal-header
        :header-title="$t('WHATSAPP_TEMPLATES.MODAL.TITLE')"
        :header-content="modalHeaderContent"
      />
      <div class="row modal-content">
        <TemplatesPicker
          v-if="!selectedWaTemplate"
          :inbox-id="inboxId"
          @on-select="pickTemplate"
        />
        <WhatsAppTemplateReply
          v-else
          :template="selectedWaTemplate"
          :contact="contact"
          @reset-template="onResetTemplate"
          @send-message="onSendMessage"
        />
      </div>
    </woot-modal>
  </TeleportWithDirection>
</template>

<style scoped>
.modal-content {
  padding: 1.5625rem 2rem;
}
</style>
